import React from 'react';

import Section, { Props as SectionProps } from '@hero/ui-kit/layout/Section';
import Tooltip from '@hero/ui-kit/components/Tooltip';
import SparklesIcon from '../../icons/SparklesIcon';
import * as Style from './style.module.scss';

const AI_LABEL = 'AI-generated';
const AI_TOOLTIP =
    'This content is AI-generated and may not always be accurate. Please review and verify before making clinical decisions.';
const HIPAA_TOOLTIP =
    'Member data processed through this feature is used SOLELY to generate the AI-driven summary displayed in the enterprise portal.\nData is NOT used for AI model training.';

type Props = SectionProps & {
    showHipaaBadge?: boolean;
};

const AISection: React.FC<Props> = ({ border, borderBottom, showHipaaBadge = false, ...rest }) => {
    return (
        <div className={Style.frame}>
            <Section {...rest} />
            <p className={Style.disclaimer}>
                <span>{AI_TOOLTIP}</span>

                {showHipaaBadge && (
                    <Tooltip
                        content={HIPAA_TOOLTIP}
                        placement="top-right"
                        width={350}
                        className={Style.hipaaBadge}
                    >
                        <img
                            src="https://img.herohealth.com/common/hipaa-compliant-badge.webp"
                            alt="HIPAA compliant"
                            className={Style.hipaaBadgeImage}
                        />
                    </Tooltip>
                )}
            </p>

            <Tooltip
                content={AI_TOOLTIP}
                width={300}
                placement="bottom-left"
                className={Style.badgeAnchor}
            >
                <button type="button" className={Style.badge} aria-label={AI_LABEL}>
                    <span className={Style.iconWrap} aria-hidden="true">
                        <SparklesIcon size="small" color="currentColor" />
                    </span>
                    <span className={Style.label}>{AI_LABEL}</span>
                </button>
            </Tooltip>
        </div>
    );
};

export default AISection;
